var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManuteno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xC3\x8Dcone Manuten\xC3\xA7\xC3\xA3o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.1005 11.938C48.1005 15.7877 45.9715 19.1124 42.8801 20.8914V37.9234H32.4685V20.8914C29.377 19.1124 27.248 15.7877 27.248 11.938C27.248 7.73834 29.7562 4.0928 33.3434 2.45959V12.7546L37.6597 16.0502L42.0052 12.7838V2.48876C44.5133 3.62617 46.4673 5.726 47.4298 8.29246L44.28 9.31321L47.9839 10.5089C48.0714 10.9756 48.1005 11.4422 48.1005 11.938V11.938Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.6191 37.9235H47.8973C49.6472 37.9235 51.0471 39.3233 51.0471 41.0732C51.0471 42.8231 49.6472 44.223 47.8973 44.223H35.6191",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.6191 44.2227H48.8306C50.5804 44.2227 51.9803 45.6225 51.9803 47.3724C51.9803 49.1223 50.5804 50.5221 48.8306 50.5221H35.6191",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.6191 50.5223H47.8973C49.6472 50.5223 51.0471 51.9222 51.0471 53.6721C51.0471 55.4219 49.6472 56.8218 47.8973 56.8218H35.6191",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M35.6172 56.8219H45.9413C47.6912 56.8219 49.0911 58.2218 49.0911 59.9716C49.0911 61.7215 47.6912 63.1214 45.9413 63.1214H35.6172H25.4388C24.593 63.1214 23.7764 62.8589 23.1057 62.3631L20.9475 60.7591C20.2767 60.2633 19.4601 60.0008 18.6144 60.0008H15.8438",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.8155 32.7322H1V63.1214H15.8155V32.7322Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.8164 35.7945H18.3245C19.4911 35.7945 20.6285 35.3278 21.4451 34.5112L25.9364 30.0199C26.753 29.2033 27.8904 28.7367 29.057 28.7367H32.4401",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M37.6602 37.9234V26.5493",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M55.5659 7.59248C54.9826 7.38833 54.516 6.9217 54.3118 6.33841L52.5911 1.00134L50.8704 6.33841C50.6663 6.9217 50.1997 7.38833 49.6164 7.59248L47.429 8.29242L44.2793 9.31317L47.9832 10.5089L49.6164 11.0339C50.1997 11.238 50.6663 11.7046 50.8704 12.2879L52.5911 17.625L54.3118 12.2879C54.516 11.7046 54.9826 11.238 55.5659 11.0339L60.903 9.31317L55.5659 7.59248V7.59248Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M54.8079 19.8414L56.5286 25.1785C56.7328 25.7618 57.1994 26.2284 57.7827 26.4326L63.1198 28.1533L57.7827 29.874C57.1994 30.0781 56.7328 30.5447 56.5286 31.128L54.8079 36.4651L53.0872 31.128C52.8831 30.5447 52.4164 30.0781 51.8332 29.874L46.4961 28.1533L51.8332 26.4326C52.4164 26.2284 52.8831 25.7618 53.0872 25.1785L54.8079 19.8414V19.8414Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M21.3001 14.7377L23.0208 20.0747C23.225 20.658 23.6916 21.1247 24.2749 21.3288L29.6119 23.0495L24.2749 24.7702C23.6916 24.9743 23.225 25.441 23.0208 26.0243L21.3001 31.3613L19.5794 26.0243C19.3753 25.441 18.9086 24.9743 18.3254 24.7702L12.9883 23.0495L18.3254 21.3288C18.9086 21.1247 19.3753 20.658 19.5794 20.0747L21.3001 14.7377V14.7377Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M8.78746 58.3092C9.93106 58.3092 10.8581 57.3821 10.8581 56.2385C10.8581 55.0949 9.93106 54.1678 8.78746 54.1678C7.64387 54.1678 6.7168 55.0949 6.7168 56.2385C6.7168 57.3821 7.64387 58.3092 8.78746 58.3092Z",
    stroke: "#FF7A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuteno);
export default __webpack_public_path__ + "static/media/Manutenção.f98015441fb7acfbb04d3e9c72b3cc2c.svg";
export { ForwardRef as ReactComponent };